// Name.js
import React from 'react';
import { useParams, } from 'react-router-dom';
import { motion } from 'framer-motion';


const Name = () => {
  const { guestName } = useParams();


  return (
    
      
      <motion.h2 className="mt-1 ">{guestName}</motion.h2>
      

  );
};

export default Name;
